import { SubscriberCreateRequest } from "core/types/SubscriberCreateRequest";

export class SubscriberRenewalRequest extends SubscriberCreateRequest {
  subscriberId = null;

  personId = null;

  /**
   * @type {Boolean}
   */
  useActiveCard = null;

  constructor(subscriberId = null, personId = null, useActiveCard = null) {
    super();

    this.subscriberId = subscriberId || null;
  }
}
